import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import type { EmergencyFormState } from '../types/emergencyFormState.types';

const emergencyFormSlice = createSlice({
  name: 'emergencyCare/emergencyForm',
  initialState,
  reducers: {
    //* ------------------------------------------------------------------------
    updateFormData: (state, action: PayloadAction<EmergencyFormState['formData']>) => {
      state.formData = { ...state.formData, ...action.payload };
    },

    //* ------------------------------------------------------------------------
    resetFormData: (state) => {
      state.formData = {};
    },
  },
});

export const { resetFormData, updateFormData } = emergencyFormSlice.actions;
export default emergencyFormSlice.reducer;
